<template>
  <div v-loading="loading">
    <el-form :model="form" :rules="rules" ref="form" label-width="150px">
      <el-form-item label-width="0">
        <ul class="ul flex">
          <li class="li-active">1.企业信息</li>
          <li class="li-active-r"></li>
          <li class="li-active-l"></li>
          <li class="li-active">2.品牌与资质信息</li>
          <li class="li-active-r"></li>
          <li class="li-active-l"></li>
          <li class="li-active">3.供应商信息</li>
          <li class="li-active-r"></li>
        </ul>
      </el-form-item>
      <el-form-item label-width="0">
        <div class="title">
          <p></p>
          <p>供应商信息</p>
        </div>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人姓名" prop="contactName">
            <el-input v-model="form.contactName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人电话" prop="contactPhone">
            <el-input v-model="form.contactPhone" placeholder="请输入" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人电子邮箱">
            <el-input v-model="form.contactEmail" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="店铺名称" prop="settledName">
            <el-input v-model="form.settledName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="销售规模" prop="saleScale">
            <el-input v-model="form.saleScale" placeholder="请输入">
              <template slot="append">万元/年</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="销售区域" required>
        <el-radio-group v-model="supplierSettledAreaRadio">
          <el-radio :label="true" @click.native.prevent="supplierSettledAreaRadioChange(true)">全国</el-radio>
          <el-radio :label="false" @click.native.prevent="supplierSettledAreaRadioChange(false)">区域</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="公司人数" prop="staffNum">
            <el-input v-model="form.staffNum" placeholder="请输入">
              <template slot="append">人</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="承诺发货时效" prop="deliveryTime">
        <el-radio-group v-model="form.deliveryTime">
          <el-radio :label="24">24小时</el-radio>
          <el-radio :label="48">48小时</el-radio>
          <el-radio :label="72">72小时</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="银行账号名称" prop="accountName">
            <el-input v-model="form.accountName" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="银行卡卡号" prop="bankAccount">
            <el-input v-model="form.bankAccount" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="开户行" prop="accountsBank">
            <el-input v-model="form.accountsBank" placeholder="请输入">
              <template slot="append">
                <el-button type="primary" @click="queryLHH">查询联行号</el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="开户行联行号" prop="cnapsCode">
            <el-input v-model="form.cnapsCode" placeholder="系统根据上方开户行识别，请填写正确后查询" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="所在省份" required>
        <div class="flex">
          <el-form-item prop="provinceId">
            <el-select v-model="form.provinceId" clearable placeholder="请选择" @change="value => getAddress_(value, 2)">
              <el-option v-for="item in provinceData" :key="item.id" :label="item.areaName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="cityId">
            <el-select v-model="form.cityId" clearable placeholder="请选择" @change="value => getAddress_(value, 3)">
              <el-option v-for="item in cityData" :key="item.id" :label="item.areaName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="districtId">
            <el-select v-model="form.districtId" clearable placeholder="请选择">
              <el-option v-for="item in districtData" :key="item.id" :label="item.areaName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form-item>
      <div class="textC">
        <el-button @click="$router.go(-1)">上一步</el-button>
        <el-button type="primary" @click="handleNext">提交</el-button>
      </div>
    </el-form>

    <el-dialog title="销售区域" :visible.sync="supplierSettledAreaShow" width="50%">
      <el-tree :data="areaData" show-checkbox node-key="id" ref="tree"
        :default-checked-keys="form.supplierSettledAreaList ? form.supplierSettledAreaList.map(item => item.cityId) : []"
        :props="{
          label: 'areaName',
          children: 'subAreas',
        }">
      </el-tree>
      <span slot="footer">
        <el-button @click="supplierSettledAreaShow = false">取 消</el-button>
        <el-button type="primary" @click="supplierSettledAreaSure">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择联行号 -->
    <el-dialog title="选择联行号" :visible.sync="showLHH" width="30%">
      <el-select v-model="lhhValue" placeholder="请选择" style="width:100%;">
        <el-option v-for="item in LHHData" :key="item.bankCode" :label="item.lName + '(' + item.bankCode + ')'"
          :value="item.bankCode">
        </el-option>
      </el-select>
      <span slot="footer">
        <el-button @click="showLHH = false">取 消</el-button>
        <el-button type="primary" @click="selectLHH">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  KSAXApiRequest,
} from "../../api/api";

export default {
  components: {},
  data() {
    return {
      loading: false,
      form: {},
      rules: {
        contactName: [{ required: true, message: '请填写', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '请填写', trigger: 'blur' }],
        settledName: [{ required: true, message: '请填写', trigger: 'blur' }],
        saleScale: [{ required: true, message: '请填写', trigger: 'blur' }],
        staffNum: [{ required: true, message: '请填写', trigger: 'blur' }],
        deliveryTime: [{ required: true, message: '请选择', trigger: 'change' }],
        accountName: [{ required: true, message: '请填写', trigger: 'blur' }],
        bankAccount: [{ required: true, message: '请填写', trigger: 'blur' }],
        accountsBank: [{ required: true, message: '请填写', trigger: 'blur' }],
        cnapsCode: [{ required: true, message: '请填写', trigger: 'blur' }],
        provinceId: [{ required: true, message: '请选择', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择', trigger: 'change' }],
        districtId: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      provinceData: [],
      cityData: [],
      districtData: [],
      supplierSettledAreaRadio: true,
      supplierSettledAreaShow: false,
      areaData: [],

      showLHH: false,
      allLHHData: [],
      LHHData: [],
      lhhValue: null
    };
  },
  created() {
    this.getDetail()
    this.getAreaData()
  },
  mounted() {

  },
  methods: {
    queryLHH() {
      if (this.allLHHData.length && this.allLHHData.find(i => i.key == this.form.accountsBank)) {
        this.LHHData = (this.allLHHData.find(i => i.key == this.form.accountsBank)).data
        this.lhhValue = null
        this.showLHH = true
      } else {
        KSAXApiRequest({
          path: "Ali/GetBankApData",
          parms: `key=${this.form.accountsBank}`,
          // parms: `key=招商银行上海联洋支行`,
          parmsJson: {}
        }).then(res => {
          if (!res.data) {
            return this.$message.error('未查询到联行号')
          }
          if (res.data.record.length) {
            this.LHHData = res.data.record
            this.allLHHData.push({
              key: this.form.accountsBank,
              data: res.data.record
            })
            this.lhhValue = null
            this.showLHH = true
          }
        })
      }
    },
    selectLHH() {
      if (!this.lhhValue) return this.$message.error('请选择联行号')
      this.form.cnapsCode = this.lhhValue
      this.showLHH = false
    },
    getAreaData() {
      let data = {
        path: "Product_Spu/SpuAreaShowTreeList",
        parms: "",
        parmsJson: {}
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.areaData = res.data.response
          this.areaData.forEach(a => {
            a.subAreas.forEach(b => {
              b.parentId = a.id
            })
          });
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getDetail() {
      let data = {
        path: "Business_SupplierSettled/AddSupplierSettled",
        parms: "",
        parmsJson: {
          contactPhone: this.$route.query.phone,
          step: 0,
        }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          res.data.response.supplierSettledAreaList = []
          this.form = res.data.response
          this.form.accountName = res.data.response.companyName
          this.getAddress(null, 1)
          this.getAddress(this.form.provinceId, 2)
          this.getAddress(this.form.cityId, 3)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getAddress_(parentId, areaLevel) {
      if (areaLevel === 2) {
        this.cityData = []
        this.districtData = []
        this.form.cityId = null
        this.form.districtId = null
      }
      if (areaLevel === 3) {
        this.districtData = []
        this.form.districtId = null
      }
      this.getAddress(parentId, areaLevel)
    },
    getAddress(parentId, areaLevel) {
      let data = {
        path: "System_Area/List",
        parms: "",
        parmsJson: {
          parentId,
          areaLevel
        }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          if (areaLevel === 1) {
            this.provinceData = res.data.response.data
          }
          if (areaLevel === 2) {
            this.cityData = res.data.response.data
          }
          if (areaLevel === 3) {
            this.districtData = res.data.response.data
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleNext() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.accountName) {
            if (/\s/.test(this.form.accountName)) {
              return this.$message.error('银行账号名称不能含有空格')
            }
          }
          if (this.form.accountsBank) {
            if (/\s/.test(this.form.accountsBank)) {
              return this.$message.error('开户行不能含有空格')
            }
          }
          if (this.form.bankAccount) {
            if (/\s/.test(this.form.bankAccount)) {
              return this.$message.error('银行卡卡号不能含有空格')
            }
            if (!/^\d+$/.test(this.form.bankAccount)) {
              return this.$message.error('银行卡卡号只能是数字类型')
            }
          }
          if (this.form.cnapsCode) {
            if (/\s/.test(this.form.cnapsCode)) {
              return this.$message.error('开户行联行号不能含有空格')
            }
            if (!/^\d+$/.test(this.form.cnapsCode)) {
              return this.$message.error('开户行联行号只能是数字类型')
            }
          }
          let data = {
            path: "Business_SupplierSettled/AddSupplierSettled",
            parms: "",
            parmsJson: {
              ... this.form,
              step: 3,
              provinceName: this.provinceData.filter(item => item.id === this.form.provinceId)[0].areaName,
              cityName: this.cityData.filter(item => item.id === this.form.cityId)[0].areaName,
              districtName: this.districtData.filter(item => item.id === this.form.districtId)[0].areaName,
            }
          }
          this.loading = true
          KSAXApiRequest(data).then(res => {
            this.loading = false
            if (res.data.success) {
              this.$router.push(`/SupEnter/State?step=1`)
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      });
    },
    supplierSettledAreaRadioChange(value) {
      this.supplierSettledAreaRadio = value
      if (this.supplierSettledAreaRadio) {
        this.form.supplierSettledAreaList = []
        this.$refs.tree.setCheckedKeys([]);
      } else {
        this.supplierSettledAreaShow = true
      }
    },
    supplierSettledAreaSure() {
      this.supplierSettledAreaShow = false
      this.form.supplierSettledAreaList = this.$refs.tree.getCheckedNodes().map(item => {
        return {
          provinceId: item.parentId,
          cityId: item.id,
          distinctId: 0
        }
      })
    }
  },
};
</script>

<style scoped>
.ul li {
  padding: 0 30px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.li-active {
  background: #3B6FFA;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: bold;
  font-size: 14px;
  color: #FFFFFF;
}

.li-active-r {
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  border-left: 10px solid #3B6FFA;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
}

.li {
  background: #EBF2FA;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.li-r {
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  border-left: 10px solid #EBF2FA;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
}

.li-l {
  margin-left: -5px;
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  border-left: 10px solid transparent;
  border-top: 18px solid #EBF2FA;
  border-bottom: 18px solid #EBF2FA;
}

.li-active-l {
  margin-left: -5px;
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  border-left: 10px solid transparent;
  border-top: 18px solid #3B6FFA;
  border-bottom: 18px solid #3B6FFA;
}

.title {
  background: #ecf5ff;
  display: flex;
  align-items: center;
}

.title p:first-child {
  height: 40px;
  width: 4px;
  background-color: #3B6FFA;
}

.title p:last-child {
  margin-left: 10px;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
}
</style>
